import { Suspense, lazy } from "react";
import { RenderLoadingSpinnerInImageTag } from "./Helper";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import speech_BubbleGif from "../../videos/speech_Bubble.gif";
import { CreateUniqId, useScrollToTop } from "../../Utility";
import { useFormik } from "formik";

// * import method different because its a lazy load import
const Header = lazy(() => import(`./Components/Profile/Header`));

export default function ProfileDelete() {
  // * At the top of the page.
  useScrollToTop();

  // * Start ***Enable Dark Mode Feature***
  const darkModeState = useSelector((state) => state.setMode).darkMode;
  const accountBackGroundDynamic = useSelector((state) => state.setMode).css
    ?.accountPageBackground;
  const textLightColorDynamic = useSelector((state) => state.setMode).css
    ?.textLightColor;
  const textColorDynamic = useSelector((state) => state.setMode).css?.textColor;

  const requirementsArray = [
    {
      title:
        "I am no longer a member of any MongoDB Atlas or Cloud Manager projects.",
      details:
        "If you are a Project Owner with other members, promote another user to Project Owner. If you are the sole user of a project, delete the project.",
      gif: speech_BubbleGif,
      ingAlt: "speech_BubbleGif",
    },
  ];

  const acknowledgementsArray = [
    {
      title:
        "I understand that once I submit my account deletion request, I will no longer have access to my jsonOnClouds account.",
      details:
        "You will no longer be able to log in and access Cloud, Support, Community, and Feedback Forums.",
      id: "noLongerHaveAccess",
    },
    {
      title:
        "I understand that once my account is marked for deletion, I will not be able to undo this request.",
      details:
        "Upon deletion, jsonOnClouds will permanently deactivate your account and remove your profile.",
      id: "notAbleUndoRequest",
    },
    {
      title:
        "I understand that once my jsonOnClouds account is deleted, all of my data will be permanently erased.",
      details:
        "This includes personal data and data stored across Cloud, Support, Community, and Feedback Forums.",
      id: "dataPermanentlyErased",
    },
    {
      title: "I understand that I must verify my identity on the next screen.",
      details:
        "I understand that I need to verify my identity on the next screen.",
      id: "verifyMyIdentity",
    },
  ];

  // * Handel Acknowledgements checkboxes
  const initialValuesForAcknowledgements = {
    checkboxValue: false,
  };

  const { handleChange, handleSubmit } = useFormik({
    initialValues: initialValuesForAcknowledgements,
    onSubmit: (formValues) => {
      console.log("Form submitted:", formValues);
    },
  });

  return (
    <>
      {/* Header */}
      <header>
        <Suspense
          fallback={RenderLoadingSpinnerInImageTag(
            "w-20",
            "h-20",
            "Header Lodging"
          )}
        >
          <Header />
        </Suspense>
      </header>

      <div className={` min-h-screen py-[8vh] ${accountBackGroundDynamic}`}>
        <div
          className={` max-w-[90vw] md:max-w-[85vw] lg:max-w-[80vw]  mx-auto space-y-11 `}
        >
          {/* Account Delete jsonOnClouds Account */}
          <h5
            className={` text-sm uppercase font-bold font-sans ${
              darkModeState ? " text-Brand-Color " : " text-blue-600 "
            }  `}
          >
            <Link
              to={""}
              className={` hover:underline hover:decoration-current `}
            >
              Account
            </Link>{" "}
            {">"}{" "}
            <span className={` hover:underline hover:decoration-current `}>
              {" "}
              Delete jsonOnClouds Account
            </span>
          </h5>
          {/* Delete jsonOnClouds Account */}
          <h1
            className={` text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold font-mono ${textColorDynamic}`}
          >
            Delete jsonOnClouds Account
          </h1>

          {/* Requirements */}
          <section
            className={` relative py-6 px-5 space-y-3 shadow-xl rounded-3xl border overflow-hidden ${
              darkModeState
                ? " bg-[#001e2b] border-[#38b982] "
                : " bg-white border-[#38b9813b]"
            }`}
          >
            <h3 className={` text-lg font-bold font-mono ${textColorDynamic}`}>
              Requirements
            </h3>
            <p className={` ${textLightColorDynamic}`}>
              {" "}
              Review and ensure that you meet the following conditions before
              proceeding.
            </p>
            {/* List main container */}
            <div className={` space-y-8`}>
              {/* List */}
              {requirementsArray.map((element, Index) => (
                <div
                  key={CreateUniqId(
                    "ProfileDelete-",
                    `-requirements-Index-${Index}`
                  )}
                  className={` flex flex-wrap `}
                >
                  <div className={` basis-1/4 sm:basis-1/6 lg:basis-1/12  `}>
                    {/* Img container */}
                    <div className={``}>
                      <img
                        src={element.gif}
                        alt={element.ingAlt}
                        loading="lazy"
                        className={` w-20 h-20 bg-white rounded-lg shadow-inner border ${
                          darkModeState
                            ? "  border-[#38b982] "
                            : " border-[#38b9813b]"
                        }  
   }`}
                      />
                    </div>
                  </div>
                  <div
                    className={` ps-2 space-y-3 md:ps-4 lg:ps-6 basis-3/4  sm:basis-10/12 lg:basis-11/12 `}
                  >
                    <h3
                      className={` text-sm  md:text-base lg:text-lg font-bold font-serif ${textColorDynamic}`}
                    >
                      {element.title}
                    </h3>
                    <p className={` ${textLightColorDynamic}`}>
                      {element.details}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Acknowledgements */}
          <section
            className={` relative py-6 px-5 space-y-5 shadow-xl rounded-3xl border overflow-hidden ${
              darkModeState
                ? " bg-[#001e2b] border-[#38b982] "
                : " bg-white border-[#38b9813b]"
            }`}
          >
            <h3 className={` text-lg font-bold font-mono ${textColorDynamic}`}>
              Acknowledgements
            </h3>
            <p className={` ${textLightColorDynamic}`}>
              {" "}
              Review the following statements carefully and check all boxes to
              proceed.
            </p>
            {/* List main container */}
            <form
              onSubmit={handleSubmit}
              action="#"
              method="POST"
              className={` space-y-6 md:space-y-8`}
            >
              {/* {acknowledgementsArray.map((element, index) => (
                <div
                  key={CreateUniqId(
                    "ProfileDelete-",
                    `-acknowledgementsLIst-Index-${index}`
                  )}
                  className={` flex  space-x-3`}
                >
                  <input
                    type="radio"
                    id={element.id}
                    name={element.id}
                    onChange={handleChange}
                    className="form-Acknowledgements-CheckBox h-5 w-5 rounded-xl transition duration-150 ease-in-out"
                  />

                  <div className={``}>
                    <label
                      className={` text-sm md:text-base font-bold ${textColorDynamic}`}
                    >
                      {element.title}
                    </label>
                    <p
                      className={` text-sm font-normal ${textLightColorDynamic}`}
                    >
                      {element.details}
                    </p>
                  </div>
                </div>
              ))} */}

              <div className={` flex  space-x-3`}>
                <input
                  type="checkbox"
                  name="noLongerHaveAccess"
                  onChange={handleChange}
                  required
                  className="form-Acknowledgements-CheckBox h-5 w-5 rounded-xl transition duration-150 ease-in-out"
                />
                <div className={``}>
                  <label
                    className={` text-sm md:text-base font-bold ${textColorDynamic}`}
                  >
                    {acknowledgementsArray[0].title}
                  </label>
                  <p
                    className={` text-sm font-normal ${textLightColorDynamic}`}
                  >
                    {acknowledgementsArray[0].details}
                  </p>
                </div>
              </div>
              <div className={` flex  space-x-3`}>
                <input
                  type="checkbox"
                  name="notAbleUndoRequest"
                  onChange={handleChange}
                  required
                  className="form-Acknowledgements-CheckBox h-5 w-5 rounded-xl transition duration-150 ease-in-out"
                />

                <div className={``}>
                  <label
                    className={` text-sm md:text-base font-bold ${textColorDynamic}`}
                  >
                    {acknowledgementsArray[1].title}
                  </label>
                  <p
                    className={` text-sm font-normal ${textLightColorDynamic}`}
                  >
                    {acknowledgementsArray[1].details}
                  </p>
                </div>
              </div>
              <div className={` flex  space-x-3`}>
                <input
                  type="checkbox"
                  name="dataPermanentlyErased"
                  onChange={handleChange}
                  required
                  className="form-Acknowledgements-CheckBox h-5 w-5 rounded-xl transition duration-150 ease-in-out"
                />

                <div className={``}>
                  <label
                    className={` text-sm md:text-base font-bold ${textColorDynamic}`}
                  >
                    {acknowledgementsArray[2].title}
                  </label>
                  <p
                    className={` text-sm font-normal ${textLightColorDynamic}`}
                  >
                    {acknowledgementsArray[2].details}
                  </p>
                </div>
              </div>
              <div className={` flex  space-x-3`}>
                <input
                  type="checkbox"
                  name="verifyMyIdentity"
                  onChange={handleChange}
                  required
                  className="form-Acknowledgements-CheckBox h-5 w-5 rounded-xl transition duration-150 ease-in-out"
                />

                <div className={``}>
                  <label
                    className={` text-sm md:text-base font-bold ${textColorDynamic}`}
                  >
                    {acknowledgementsArray[3].title}
                  </label>
                  <p
                    className={` text-sm font-normal ${textLightColorDynamic}`}
                  >
                    {acknowledgementsArray[3].details}
                  </p>
                </div>
              </div>

              {/* Delete button */}
              <button
                type="submit"
                className={` flex flex-wrap justify-center items-center text-base font-bold font-mono bg-[#f9fbfa]  py-2 px-3 md:py-3 md:px-4 space-x-2 text-[#102c38] border border-[#102c38] rounded-lg shadow-inner hover:scale-90 ease-in-out duration-300 `}
              >
                <i class="ri-account-pin-circle-fill text-lg"></i>
                <h4>Conform Account Deletion</h4>
              </button>
            </form>
          </section>
        </div>
      </div>
    </>
  );
}
